import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { BehaviorSubject } from "rxjs";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ForumsService {
  private forumCreatedSource = new Subject<string>();
  forumCreated$ = this.forumCreatedSource.asObservable();
  //forumUpdatedSource$ = new Subject<boolean>();

  constructor(private http: HttpClient) {}

  forumCreated(id: string) {
    this.forumCreatedSource.next(id);
  }
  getAllCategoryForum(id, auth_key) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_user", id);
    return this.http.post<any>(
      environment.urlForo + "?opcion=1",
      formData,
      options
    );
  }

  getTredingForums(id, auth_key) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_user", id);
    return this.http.post<any>(
      environment.urlForo + "?opcion=4",
      formData,
      options
    );
  }

  getNewsForums(id, auth_key) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_user", id);
    return this.http.post<any>(
      environment.urlForo + "?opcion=2",
      formData,
      options
    );
  }

  crearForum(id, auth_key, file, data) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_user", id);
    formData.append("Foro[nombre_foro]", data.nombre_foro);
    formData.append("Foro[imagen]", data.srcImg);
    formData.append("Foro[id_categoria]", data.idCategory);
    formData.append("Comentarios[descripcion]", data.first_comment);
    formData.append("Comentarios[id_foro]", "0");
    formData.append("Comentarios[id_user]", id);
    return this.http.post<any>(
      environment.urlForo + "?opcion=3",
      formData,
      options
    );
  }

  getCommentsByForum(id, auth_key, id_foro) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_user", id);
    formData.append("id_foro", id_foro);
    return this.http.post<any>(
      environment.urlForo + "?opcion=5",
      formData,
      options
    );
  }

  crearComment(
    id,
    auth_key,
    id_foro,
    descripcion,
    id_comentario = null,
    resp_user = null
  ) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_user", id);
    formData.append("Comentarios[id_foro]", id_foro);
    formData.append("Comentarios[descripcion]", descripcion);
    if (resp_user != null) formData.append("Comentarios[resp_user]", resp_user);
    if (id_comentario != null)
      formData.append("Comentarios[id_comentario]", id_comentario);
    return this.http.post<any>(
      environment.urlForo + "?opcion=6",
      formData,
      options
    );
  }

  editComment(id, auth_key, id_comentario, descripcion, id_foro) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_user", id);
    formData.append("Comentarios[id]", id_comentario);
    formData.append("Comentarios[id_foro]", id_foro);
    formData.append("Comentarios[descripcion]", descripcion);
    return this.http.post<any>(
      environment.urlForo + "?opcion=7",
      formData,
      options
    );
  }

  getForumById(id, auth_key, id_foro) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_user", id);
    formData.append("id_foro", id_foro);
    return this.http.post<any>(
      environment.urlForo + "?opcion=12",
      formData,
      options
    );
  }

  sendLikeAndDislike(id, auth_key, id_foro, id_comentario, opcion, typeModel) {
    console.log(id_comentario, opcion, typeModel);

    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_user", id);
    formData.append(typeModel + "[id_user]", id);
    if (id_foro != null) formData.append(typeModel + "[id_foro]", id_foro);
    if (id_comentario != null)
      formData.append(typeModel + "[id_comentario]", id_comentario);
    return this.http.post<any>(
      environment.urlForo + "?opcion=" + opcion,
      formData,
      options
    );
  }

  getForumsbyCategory(id, auth_key, id_categoria) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_user", id);
    formData.append("id_categoria", id_categoria);
    return this.http.post<any>(
      environment.urlForo + "?opcion=13",
      formData,
      options
    );
  }

  getMyForums(id, auth_key) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_user", id);
    return this.http.post<any>(
      environment.urlForo + "?opcion=14",
      formData,
      options
    );
  }

  findForums(id, auth_key, text) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_user", id);
    formData.append("text", text);
    return this.http.post<any>(
      environment.urlForo + "?opcion=15",
      formData,
      options
    );
  }
}
